import script from "./Badge.vue?vue&type=script&setup=true&lang=js"
export * from "./Badge.vue?vue&type=script&setup=true&lang=js"

import "./Badge.vue?vue&type=style&index=0&id=1bc08388&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1bc08388"]])

export default __exports__